import styled from "styled-components";

export const ChangelogComponentMainDiv = styled.main``;

export const ChangelogComponentHeroMainDiv = styled.section`
  > div {
    display: flex;
    gap: 10px;
    width: 100%;
    padding: 210px 40px 100px;
    align-items: center;
    justify-content: center;
  }
  .changelog-container {
    display: flex;
    flex-flow: column;
    gap: 120px;
    max-width: 810px;
    width: 100%;
    flex: 1;
    max-width: 1140px;
  }

  .changelog-header-container {
    display: flex;
    flex-flow: column;
    gap: 12px;
    max-width: 810px;
    width: 100%;
    flex: 1;
    max-width: 1140px;
    align-items: center;
    justify: center;
  }

  .changelog-header-text-container {
    width: 100%;
    flex: 1;
    max-width: 700px;
    > h1 {
    }
  }
  .changelog-body-container {
    display: flex;
    flex-flow: column;
    gap: 120px;
    width: 100%;
    flex: 1;
    height: min-content;
  }
`;
export const ChangelogComponentChangesItemDiv = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  gap: 24px;
  align-items: start;
  justify-content: space-between;

  .changelog-left-col {
    display: flex;
    flex-flow: column;
    gap: 8px;
    position: sticky;
    top: 150px;
    width: 100%;
    flex: 1;
    max-width: 190px;
  }
  .changelog-text-wrapper {
    > h3 {
      font-size: 26px;
      font-weight: 400;
    }
    p {
      opacity: 0.7;
      line-height: 1.4em;
    }
  }
  .changelog-right-col {
    display: flex;
    width: 61%;
    display: flex;
    flex-flow: column;
    gap: 40px;
  }
  .changelog-image-wrapper {
    width: 100%;
    height: 362px;
    border-radius: 16px;
    > img {
      border-radius: 16px;
    }
  }
  .changelog-texts-container {
    display: flex;
    flex-flow: column;
    gap: 24px;
    
    width: 100%;
    flex: 1;
    align-itmes: center;
  }
  .changelog-body-text-container {
    display: flex;
    flex-flow: column;
    gap: 40px;
    width: 100%;
    flex: 1;
    align-itmes: center;
  }
  .changelog-change-text-wrapper {
    > h3 {
      font-size: 40px;
    }
    > p {
    color: #a4a3a3ff;
     >b{
          opacity:1;
          font-size:18px;
          color:white;

     }
    }
  }
  .changelog-change-icon-wrapper {
    width: 24px;
    height: 24px;
    > svg {
      color: white;
      fill: white;
      width: 20px;
      height: 20px;
    }
  }
  .changelog-change-detail-wrapper {
    display: flex;
    align-items: center;
    gap:10px;
    width:100%;
  }
    .changelog-changes-detial-wrapper{
      display: flex;
    align-items: center;
    gap:8px;
    width:100%;
    flex-flow:column;
    }
`;
